import React, { useEffect, useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
export const Grid = () => {
    const [showGridLines, setShowGridLines] = useState(false);

    const storageKey = 'bva:grid-lines';

    const toggleGridlines = setShowGridLines.bind(null, (cV) => {
        localStorage.setItem(storageKey, String(!cV));
        return !cV;
    });

    useEffect(() => {
        window.toggleGridlines = toggleGridlines;

        const inStorage = localStorage.getItem(storageKey);

        if (inStorage) {
            setShowGridLines(inStorage === 'true');
        }

        const toggleGridWithKeys = (event) => {
            // CTRL + Shift + 4
            if (event.ctrlKey && event.shiftKey && (Number(event.key) === 4) || event.key === '$' ) {
                toggleGridlines();
            }
        };

        window.addEventListener('keydown',toggleGridWithKeys);

        return () => {
            window.removeEventListener('keydown', toggleGridWithKeys);
        };
    }, []);

    if (!showGridLines) {
        return null;
    }

    return (
        <div
            className='fixed inset-0 pointer-events-none'
            style={{ zIndex: '9999' }}>
            <div className='layout-container layout-site-outer-padding h-screen'>
                <div className='col-wrapper flex flex-wrap h-full'>
                    {Array(12).fill(null).map((_, i) => {
                        const wrapperClasses = ['h-full', 'w-1/6', 'sm:w-1/12', 'px-8'];

                        if (i >= 6) {
                            wrapperClasses.push('hidden', 'sm:block');
                        }

                        return (
                            <div
                                className={wrapperClasses.join(' ')}
                                key={i}>
                                <div
                                    className='h-full'
                                    style={{ backgroundColor: '#ff00000f' }} />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Grid;
